var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10557 0.788856C9.4741 0.0518072 10.5259 0.0518057 10.8944 0.788854L19.2764 17.5528C19.6088 18.2177 19.1253 19 18.382 19H1.61803C0.874653 19 0.391156 18.2177 0.723607 17.5528L9.10557 0.788856Z",
    fill: "#A40000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9873 6.04688L10.7617 12.958H9.12109L8.88867 6.04688H10.9873ZM8.83398 15.0977C8.83398 14.806 8.93424 14.5645 9.13477 14.373C9.33984 14.1771 9.60872 14.0791 9.94141 14.0791C10.2786 14.0791 10.5475 14.1771 10.748 14.373C10.9486 14.5645 11.0488 14.806 11.0488 15.0977C11.0488 15.3802 10.9486 15.6195 10.748 15.8154C10.5475 16.0114 10.2786 16.1094 9.94141 16.1094C9.60872 16.1094 9.33984 16.0114 9.13477 15.8154C8.93424 15.6195 8.83398 15.3802 8.83398 15.0977Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorWarning);
export default __webpack_public_path__ + "static/media/error_warning.d8721998.svg";
export { ForwardRef as ReactComponent };